import React, { useState, useEffect } from "react";
import logo from "../assets/logo/tamworld_logo.png";
import { Link } from "react-router-dom";

// ── Constants ─────────────────────────────────────────────────────────────────
const C = {
  gold: "#f5c518",
  goldD: "#d4a80f",
  dark: "#1a1a2e",
  border: "#e5e7eb",
  gray: "#6b7280",
  white: "#ffffff",
};

const F = {
  display: "'Playfair Display', serif",
  body: "'Plus Jakarta Sans', sans-serif",
};

// ── Global CSS ────────────────────────────────────────────────────────────────
const HEADER_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

  @keyframes ring {
    0%   { transform: rotate(0); }
    10%  { transform: rotate(12deg); }
    20%  { transform: rotate(-10deg); }
    30%  { transform: rotate(9deg); }
    40%  { transform: rotate(-8deg); }
    50%  { transform: rotate(5deg); }
    60%  { transform: rotate(-4deg); }
    70%  { transform: rotate(2deg); }
    80%  { transform: rotate(-1deg); }
    100% { transform: rotate(0); }
  }

  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-14px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @keyframes overlayIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50%       { opacity: 0.5; transform: scale(1.4); }
  }

  /* ── Nav link hover ── */
  .hdr-nav-link {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #6b7280;
    text-decoration: none;
    padding: 8px 14px;
    border-radius: 10px;
    transition: color 0.2s ease, background 0.2s ease;
    white-space: nowrap;
    display: block;
  }
  .hdr-nav-link:hover {
    color: #1a1a2e !important;
    background: rgba(26,26,46,0.05);
  }
  .hdr-nav-link.active {
    color: #d4a80f;
    font-weight: 700;
  }

  /* ── Phone ringing ── */
  .hdr-phone {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: #b8860b;
    text-decoration: none;
    padding: 9px 16px;
    border-radius: 50px;
    background: rgba(245, 197, 24, 0.08);
    border: 1.5px solid rgba(245, 197, 24, 0.3);
    transition: background 0.2s, border-color 0.2s, transform 0.2s;
    white-space: nowrap;
    cursor: pointer;
  }
  .hdr-phone:hover {
    background: rgba(245, 197, 24, 0.16);
    border-color: rgba(245, 197, 24, 0.55);
    transform: translateY(-1px);
  }
  .hdr-phone-icon {
    display: inline-block;
    animation: ring 1.4s ease-in-out infinite;
    transform-origin: top center;
    font-size: 16px;
  }

  /* ── CTA button ── */
  .hdr-cta {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    font-weight: 700;
    background: #1a1a2e;
    color: #f5c518;
    border: none;
    border-radius: 50px;
    padding: 10px 22px;
    cursor: pointer;
    transition: background 0.2s, transform 0.2s, box-shadow 0.2s;
    white-space: nowrap;
    letter-spacing: 0.3px;
  }
  .hdr-cta:hover {
    background: #2a2a4e;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(26,26,46,0.25);
  }

  /* ── Hamburger ── */
  .hdr-hamburger {
    display: none;
    flex-direction: column;
    gap: 5px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 10px;
    transition: background 0.15s;
  }
  .hdr-hamburger:hover { background: rgba(26,26,46,0.06); }
  .hdr-hamburger span {
    display: block;
    width: 24px;
    height: 2.5px;
    background: #1a1a2e;
    border-radius: 3px;
    transition: transform 0.28s cubic-bezier(0.23,1,0.32,1), opacity 0.2s;
  }
  .hdr-hamburger.open span:nth-child(1) { transform: translateY(7.5px) rotate(45deg); }
  .hdr-hamburger.open span:nth-child(2) { opacity: 0; transform: scaleX(0); }
  .hdr-hamburger.open span:nth-child(3) { transform: translateY(-7.5px) rotate(-45deg); }

  /* ── Mobile menu overlay ── */
  .hdr-mobile-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 12, 30, 0.96);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    animation: overlayIn 0.22s ease;
    backdrop-filter: blur(12px);
  }

  .hdr-mobile-overlay .mob-link {
    font-family: 'Playfair Display', serif;
    font-size: 28px;
    font-weight: 700;
    color: rgba(255,255,255,0.82);
    text-decoration: none;
    padding: 10px 24px;
    border-radius: 14px;
    transition: color 0.2s, background 0.2s;
    letter-spacing: -0.3px;
  }
  .hdr-mobile-overlay .mob-link:hover {
    color: #f5c518;
    background: rgba(245,197,24,0.07);
  }

  .hdr-mobile-overlay .mob-divider {
    width: 60px;
    height: 1px;
    background: rgba(255,255,255,0.12);
    margin: 8px 0;
  }

  .hdr-mobile-overlay .mob-phone {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: #f5c518;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 24px;
  }

  .hdr-mobile-overlay .mob-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.12);
    color: rgba(255,255,255,0.7);
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
  }
  .hdr-mobile-overlay .mob-close:hover {
    background: rgba(255,255,255,0.15);
    color: #fff;
  }

  .hdr-mobile-overlay .mob-cta {
    margin-top: 12px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 15px;
    font-weight: 700;
    background: linear-gradient(135deg, #f5c518, #d4a80f);
    color: #1a1a2e;
    border: none;
    border-radius: 50px;
    padding: 14px 40px;
    cursor: pointer;
    letter-spacing: 0.3px;
  }

  /* ── Live dot ── */
  .hdr-live-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #f5c518;
    animation: pulse 1.8s ease-in-out infinite;
    flex-shrink: 0;
  }

  /* ── Scroll state ── */
  .hdr-nav.scrolled {
    box-shadow: 0 4px 30px rgba(0,0,0,0.10) !important;
    background: rgba(255,255,255,0.98) !important;
  }

  /* ── Responsive ── */
  @media (max-width: 768px) {
    .hdr-desktop-nav  { display: none !important; }
    .hdr-desktop-right { display: none !important; }
    .hdr-hamburger    { display: flex !important; }
  }

  @media (min-width: 769px) {
    .hdr-hamburger { display: none !important; }
  }
`;

// ── Header Component ──────────────────────────────────────────────────────────
export default function Header(defaultActive) {
 
  const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "Services", path: "/services" },
  { name: "How It Works", path: "/how-it-works" },
  { name: "Contact", path: "/contact" },
];
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState(defaultActive.defaultActive || "Home");

  // Detect scroll for shadow
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Lock body scroll when mobile menu open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  return (
    <>
      <style>{HEADER_CSS}</style>

      {/* ─── Mobile Menu Overlay ─── */}
      {menuOpen && (
        <div className="hdr-mobile-overlay">
          <button className="mob-close" onClick={() => setMenuOpen(false)}>✕</button>

          {/* Branding inside overlay */}
          <div style={{
            fontFamily: F.display,
            fontSize: 32,
            fontWeight: 900,
            color: "#fff",
            letterSpacing: "-1px",
            marginBottom: 12,
          }}>
            <span style={{ color: C.gold }}>Halo</span>Sorath
          </div>

          <div className="mob-divider" />

          {NAV_LINKS.map(l => (
            <Link
  to={l.path}
  className="mob-link"
  onClick={() => {
    setActiveLink(l.name);
    setMenuOpen(false);
  }}
>
  {l.name}
</Link>
          ))}

          <div className="mob-divider" />

          <a href="tel:+919265407669" className="mob-phone">
            <span className="hdr-phone-icon">📞</span>
            +91 92654 07669
          </a>

          
        </div>
      )}

      {/* ─── Main Navbar ─── */}
      <nav
        className={`hdr-nav${scrolled ? " scrolled" : ""}`}
        style={{
          position: "sticky",
    top: 0,
    zIndex: 100,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 8px 0 0",
    height: 80,
    overflow: "visible",
          background: "rgba(255,255,255,0.96)",
          backdropFilter: "blur(18px)",
          borderBottom: `1px solid ${C.border}`,
          transition: "box-shadow 0.3s, background 0.3s",
          fontFamily: F.body,
        }}
      >
        {/* Logo */}
        <a
          href="/"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            textDecoration: "none",
            flexShrink: 0,
          }}
        >
          <img
  src={logo}
  alt="HaloSorath"
  style={{
    height: 150,
    objectFit: "contain",
    cursor: "pointer",
    display: "block",
    marginTop: 34,
    marginLeft: -1,
    zIndex: 999,
    position: "relative",
  }}
/>
        </a>

        {/* Desktop Navigation */}
        <ul
          className="hdr-desktop-nav"
          style={{
            display: "flex",
            gap: 2,
            listStyle: "none",
            margin: 0,
            padding: 0,
            flex: 1,
            justifyContent: "center",
          }}
        >
          {NAV_LINKS.map(l => (
  <li key={l.name}>
    <Link
      to={l.path}
      className={`hdr-nav-link${activeLink === l.name ? " active" : ""}`}
      onClick={() => setActiveLink(l.name)}
    >
      {l.name}
    </Link>
  </li>
))}
        </ul>

        {/* Desktop Right Side */}
        <div
          className="hdr-desktop-right"
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            flexShrink: 0,
          }}
        >
          <a href="tel:9265407669" className="hdr-phone">
            <span className="hdr-live-dot" />
            <span className="hdr-phone-icon">📞</span>
            +91 92654 07669
          </a>
          
        </div>

        {/* Hamburger */}
        <button
          className={`hdr-hamburger${menuOpen ? " open" : ""}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>
    </>
  );
}